
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Livello 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"cls-1",attrs:{"d":"M250 76.09A173.91 173.91 0 10423.91 250 173.91 173.91 0 00250 76.09zm-24.27 225a72.67 72.67 0 1172.67-72.67 72.75 72.75 0 01-72.67 72.68zm88.43 40.59l-44.61-44.61 25.55-25.56 44.61 44.62z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M225.73 169.39a59 59 0 1059 59 59.11 59.11 0 00-59-59z"}})])
          )
        }
      }
    